/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import moment from "moment";

import { partnerHandler } from "../../partner/index";
import { borrowerSecHandler } from "../../borrowerSec/index";
import { creditAnalysisInfoHandler } from "../../creditAnalysisInfo/index";
import { limitsHandler } from "../../limits/index";
import { modalityHandler } from "../../modality/index";

function handleInitialAdjustments({
  questionnaire,
  setFieldValue,
  permissions,
  authContext,
  setBrokerIdSelected,
  operation,
  brokerList,
  cnaeClassificationData,
}) {
  return questionnaire.map(question => {

    if (permissions && (authContext.login_response.ret_value.idPersonRoot !== authContext.login_response.ret_value.applicationPersonRoot) && authContext) {
      if (question.idQuestion === 1776) {
        if (brokerList?.length > 0 && brokerList[0].id === authContext.login_response.ret_value.idPersonRoot) {
          const answer = JSON.stringify({
            id: brokerList[0].id,
            value: `${brokerList[0].insurerBrokerId} - ${brokerList[0].personName}`
          });

          question.disabled = true;
          question.answer = answer;
          question.answerJson = answer;
        }
      }
    }

    if (question.idQuestion === 1776 && question.answer) {
      const answer = JSON.parse(question.answer);
      setBrokerIdSelected(answer.id);

      /* ISSUE 1996 - PERMITIR EDIÇÃO DO CORRETOR INDEPENDENTE DO STATUS DO CCG.
      if (operation?.document?.idDomain === 689 && [422, 423, 424, 440].includes(operation?.document?.idDomainStatus)) {
      question.disabled = true;
    } */
    }

    if (question.idQuestion === 1634 && operation?.idDomainStatus) {
      question.disabled = true
    }

    if (question.idQuestion === 1634 && [425, 416, 417, 418].includes(operation?.idDomainStatus)) {
      question.behaviorObject.enableSearch = true;
    }

    if (question.idQuestion === 1637 && !question.answer) {
      question.disable = false;
      question.behaviorObject.isReadOnly = false;
    }

    if (question.idQuestion === 1637 && question.answer) {
      creditAnalysisInfoHandler.events.handleCalcPefinRefinAcoesProtCapSocial({ questionnaire, setFieldValue })
    }

    if (question.idQuestion === 1723) {
      const isEconomicGroup = questionnaire.find(qst => qst.idQuestion === 1830)?.idAnswerOption === 7415;

      if (isEconomicGroup) {
        question.behaviorObject.isReadOnly = true;
        question.disable = true
      }
    }

    if (question.idQuestion === 1723) {
      if (operation && ![417, 425].includes(operation?.idDomainStatus)) {
        question.behaviorObject.isReadOnly = true;
        question.disable = true
      }
    }

    if ([418].includes(operation?.idDomainStatus) && question.idQuestion === 1649 && question.answer) {
      questionnaire = questionnaire.map(qst => {
        if (qst.idQuestion === 1708) {
          const cnaeCode = (question?.answer?.split('-')[0] || '')?.trim();

          const cnaeClassification = cnaeClassificationData.find((cnae) => cnae.code == cnaeCode)?.appetite || '';
          const resultAnswer = qst.answerOptions.find(q => q.dsAnswerOption.toLowerCase().trim() === cnaeClassification.toLowerCase());

          if (resultAnswer) {
            const result = {
              dsAnswerOption: resultAnswer?.dsAnswerOption,
              idAnswerOption: resultAnswer?.idAnswerOption,
              resultValue: resultAnswer?.behaviorObject?.resultValue || null
            };

            qst.idAnswerOption = resultAnswer?.idAnswerOption;
            qst.answer = resultAnswer?.behaviorObject?.resultValue || 1

            setFieldValue && setFieldValue(qst.key, result);
          }
        }

        return qst;
      })
    }

    if ([418].includes(operation?.idDomainStatus) && question.idQuestion === 1649 && question.answer) {
      questionnaire = questionnaire.map(qst => {
        if (qst.idQuestion === 1708) {
          const cnaeCode = (question?.answer?.split('-')[0] || '')?.trim();

          const cnaeClassification = cnaeClassificationData.find((cnae) => cnae.code == cnaeCode)?.appetite || '';
          const resultAnswer = qst.answerOptions.find(q => q.dsAnswerOption.toLowerCase().trim() === cnaeClassification.toLowerCase());

          if (resultAnswer) {
            const result = {
              dsAnswerOption: resultAnswer?.dsAnswerOption,
              idAnswerOption: resultAnswer?.idAnswerOption,
              resultValue: resultAnswer?.behaviorObject?.resultValue || null
            };

            qst.idAnswerOption = resultAnswer?.idAnswerOption;
            qst.answer = resultAnswer?.behaviorObject?.resultValue || 1

            setFieldValue && setFieldValue(qst.key, result);
          }
        }

        return qst;
      })
    }

    return question;
  })
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
}) {
  let saveFilteredQuestionnaire = false;

  if (question.idQuestion === 1637 && value) {
    saveFilteredQuestionnaire = true;
    let response;

    questionnaireUpdated = questionnaireUpdated.map(qst => {
      if (qst.idQuestion === 1717) {

        if (value > 1000000) {
          response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7331);
        } else if (value <= 1000000) {
          response = qst.answerOptions.find(ansOp => ansOp.idAnswerOption == 7332);
        }

        qst.answer = response?.behaviorObject?.resultValue;
        qst.idAnswerOption = response.idAnswerOption;
      }
      return qst;
    })
  }

  if (question.idQuestion === 1723) {
    saveFilteredQuestionnaire = true;

    questionnaireUpdated = questionnaireUpdated.map(qst => {
      if (qst.idQuestion === 1829) {
        if (value?.idAnswerOption === 7336) {
          const foundQuestionOption = qst.answerOptions.find(v => v.idAnswerOption === 7412);

          qst.answer = foundQuestionOption?.dsAnswerOption;
          qst.answerJson = foundQuestionOption?.dsAnswerOption;
          qst.idAnswerOption = foundQuestionOption?.idAnswerOption;
          qst.behaviorObject.isReadOnly = true;
          qst.disable = true

          setFieldValue(qst.key, {
            dsAnswerOption: foundQuestionOption?.dsAnswerOption,
            idAnswerOption: foundQuestionOption?.idAnswerOption,
            resultValue: null
          })
        }

        if (value?.idAnswerOption === 7335) {
          qst.behaviorObject.isReadOnly = false;
          qst.disable = false
        }
      }

      if (qst.idQuestion === 1830) {
        if (value?.idAnswerOption === 7336) {
          const foundQuestionOption = qst.answerOptions.find(v => v.idAnswerOption === 7414);

          qst.answer = foundQuestionOption?.dsAnswerOption;
          qst.answerJson = foundQuestionOption?.dsAnswerOption;
          qst.idAnswerOption = foundQuestionOption?.idAnswerOption;
          qst.behaviorObject.isReadOnly = true;
          qst.disable = true

          setFieldValue(qst.key, {
            dsAnswerOption: foundQuestionOption?.dsAnswerOption,
            idAnswerOption: foundQuestionOption?.idAnswerOption,
            resultValue: null
          })
        }

        if (value?.idAnswerOption === 7335) {
          qst.behaviorObject.isReadOnly = false;
          qst.disable = false
        }
      }

      return qst;
    })
  }

  if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
}

function handleQuestionBlur({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    let saveFilteredQuestionnaire = false;

    if (question.idQuestion === 1637 && value) {
      creditAnalysisInfoHandler.events.handleCalcPefinRefinAcoesProtCapSocial({
        questionnaire: questionnaireUpdated,
        setFieldValue
      });
    }

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("CREDIT_ANALYSIS_INFO - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  operation,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
  partners,
  setPartners,
  CNAESecondary,
  setCNAESecondary,
  cnaeClassificationData,
  limits,
  modalitiesFeesData,
  scoreInformationData,
  modalities,
  setModalities,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {
  try {
    if (rootQuestion.idQuestion === 1634 && data?.cnaeSecundarias && CNAESecondary?.length) {
      borrowerSecHandler.events.handleCNAESecondary({
        borrowerData: data,
        CNAESecondary,
        setCNAESecondary,
        questionnaireAnswersToDelete,
        setQuestionnaireAnswersToDelete
      })
    }

    questionnaire = questionnaire.map(question => {
      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1634) {
        setFieldValue && setFieldValue(question.key, data.ni);
        question.answer = data.ni;
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1635) {
        setFieldValue && setFieldValue(question.key, data.nomeEmpresarial);
        question.answer = data.nomeEmpresarial;
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1636) {
        const date = data?.dataAbertura ? moment(data?.dataAbertura).format('DD/MM/YYYY') : '';
        setFieldValue && setFieldValue(question.key, date);
        question.answer = data.dataAbertura;
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1637) {
        let capitalSocial = data.capitalSocial;
        if (capitalSocial <= 0) capitalSocial = 0;
        capitalSocial = capitalSocial / 100;

        question.behaviorObject.isReadOnly = !!capitalSocial;
        question.behaviorObject.isRequired = true;
        setFieldValue && setFieldValue(question.key, capitalSocial);
        question.answer = capitalSocial;
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1638 && data?.telefones?.length) {
        question.answer = data?.telefones[0].ddd + data.telefones[0].numero;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && [1639, 1807].includes(question.idQuestion)) {
        setFieldValue && setFieldValue(question.key, data.correioEletronico);
        question.answer = data.correioEletronico;
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1640 && data?.endereco) {
        question.answer = data.endereco.cep;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1641 && data?.endereco) {
        question.answer = `${data?.endereco.tipoLogradouro} ${data?.endereco.logradouro}`;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1642 && data?.endereco) {
        question.answer = data.endereco.numero;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1643 && data?.endereco) {
        question.answer = data.endereco.complemento;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1644 && data?.endereco) {
        question.answer = data.endereco.bairro;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1645 && data?.endereco) {
        question.answer = data.endereco.uf;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1795 && data?.endereco) {
        question.answer = data.endereco?.municipio?.descricao;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1646 && data?.endereco?.pais) {
        question.answer = data.endereco.pais.descricao;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1649 && data?.cnaePrincipal) {
        question.answer = `${data.cnaePrincipal.codigo} - ${data.cnaePrincipal.descricao}`;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1708 && data?.cnaePrincipal) {
        const cnaeClassification = cnaeClassificationData.find((cnae) => cnae.code == data.cnaePrincipal.codigo)?.appetite || '';
        const resultAnswer = question.answerOptions.find(q => q.dsAnswerOption.toLowerCase().trim() === cnaeClassification.toLowerCase());

        const result = {
          dsAnswerOption: resultAnswer?.dsAnswerOption,
          idAnswerOption: resultAnswer?.idAnswerOption,
          resultValue: resultAnswer?.behaviorObject?.resultValue || null
        };

        question.idAnswerOption = resultAnswer?.idAnswerOption;
        question.answer = resultAnswer?.behaviorObject?.resultValue || 1

        setFieldValue && setFieldValue(question.key, result);
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1651 && data?.porte) {
        question.answer = data.porte;
        setFieldValue && setFieldValue(question.key, question.answer)
      }

      if (rootQuestion.idQuestion === 1634 && question.idQuestion === 1653 && data?.situacaoCadastral) {
        const statusMapping = {
          'Nula': 7249,
          'Ativa': 7248,
          'Suspensa': 7352,
          'Inapta': 7249,
          'Ativa Não Regular': 7249,
          'Baixada': 7353,
        }

        const status = statusMapping[data.situacaoCadastral] || 7249;
        const resultAnswer = question.answerOptions.find(q => q.idAnswerOption === status);
        const result = {
          dsAnswerOption: resultAnswer?.dsAnswerOption,
          idAnswerOption: resultAnswer?.idAnswerOption,
          resultValue: null
        };

        question.idAnswerOption = resultAnswer?.idAnswerOption;
        question.answer = resultAnswer?.dsAnswerOption;

        setFieldValue && setFieldValue(question.key, result);
      }

      if (question.idQuestion === 1707) {
        const cnaePrimario = data?.cnaePrincipal?.codigo?.substring(0, 2);
        if (!cnaePrimario || [41, 42, 43].includes(Number(cnaePrimario))) {
          question.idAnswerOption = 7311;
          question.answer = question.answerOptions.find(v => v.idAnswerOption === 7311).dsAnswerOption;
        } else {
          question.idAnswerOption = 7310;
          question.answer = question.answerOptions.find(v => v.idAnswerOption === 7310).dsAnswerOption;
        }
      }

      if (question.idQuestion === 1711) {
        if (!data.situacaoEspecial) {
          question.idAnswerOption = 7319;
          question.answer = question.answerOptions.find(v => v.idAnswerOption === 7319).dsAnswerOption;
        } else {
          question.idAnswerOption = 7320;
          question.answer = question.answerOptions.find(v => v.idAnswerOption === 7320).dsAnswerOption;
        }
      }

      return question;
    })

    partnerHandler.events.handlePartners({
      partnersData: data.socios,
      partners,
      setPartners,
      setFieldValue,
      questionnaireAnswersToDelete,
      setQuestionnaireAnswersToDelete
    });

    setQuestionnaire(questionnaire);

    setTimeout(() => {
      if (![425, 416, 417, 418].includes(operation?.idDomainStatus)) return;

      creditAnalysisInfoHandler.events.handleCalcPefinRefinAcoesProtCapSocial({
        questionnaire,
        setFieldValue
      });

      limitsHandler.events.handleLimits({
        questionnaire,
        limits,
        setFieldValue,
        operation
      });

      modalityHandler.events.handleModalities({
        questionnaire,
        modalitiesFeesData,
        scoreInformationData,
        modalities,
        setModalities,
        setFieldValue,
        questionnaireAnswersToDelete,
        setQuestionnaireAnswersToDelete,
        limitValueOverwrite: null
      });

      setQuestionnaire(questionnaire);
    }, 1000)

  } catch (e) {
    console.log('BORROWER - handleRequestSerproCnpj error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj
}

export { events };
